import React, {useState, useEffect} from 'react'

import classes from './CatalogueButton.module.css'
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import Catalogue from '@/js/Catalogue/Catalogue';
import clsx from 'clsx';
import SoundPlayer from 'react-sdk/SoundPlayer';

const CatalogueButton = () => {

  return (
    <div className={clsx(classes.CatalogueButton, Catalogue.forceClickBtn && "force_click")} onClick={() => {
        SoundPlayer.playSound("click")
        Catalogue.forceClickBtn = false
        PopupsManager.open(POPUPS.CATALOGUE, null, Catalogue.forceClickCB)
      }}>
    </div>
  );
};

export default CatalogueButton;
